export const messageString = {
  chargeChangeMessages: {
    nurse:
      // eslint-disable-next-line no-template-curly-in-string
      'I accept that ${facilityName} is responsible for paying the new rate of $${charge["LVN"]} hour if this shift is booked by an LVN and $${charge["RN"]} per hour if this shift is booked by an RN. I certify that I have the authority to override ${facilityName} contractual rates or have received approval from the appropriate party.',
    nonNurse:
      // eslint-disable-next-line no-template-curly-in-string
      "I accept ${facilityName} is responsible for paying the new rate of $${charge} per hour for this shift. I certify that I have the authority to override ${facilityName} contractual rates or have received approval from the appropriate party.",
  },
  lowChargeRateWarning: {
    nurse:
      "The rate you selected for at least one of the nurse types is below your contractual rate and lowers the chance that someone will select your shift!",
    nonNurse:
      "The rate you selected is below your contractual rate and lowers the chance that someone will select your shift!",
  },
  massCalendarUpload: {
    successMessage:
      "Congratulations! Your schedule was uploaded successfully. Please give up to 1 hour for your uploaded schedule to reflect in your Clipboard Health calendar. If we have any questions, we will contact you!",
    modalSubtext:
      "We’ll do the work for you. Just send in your calendar however you use it today, and we’ll get the shifts posted for you. Please make sure to specify the type of healthcare professional needed for each of your shifts. Remember to keep your calendar up to date by removing any shifts you no longer need filled!",
  },
  noCallNoShowCheckBoxMessage:
    "I understand that marking this shift as a no show may result in the professional's account being restricted. I confirm the information I have provided is true and correct.",
};
